module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_a-function.js
// module id = 1994
// module chunks = 2